/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { BaseUser } from "src/classes/user";
import { SuggestedUserSmall } from "src/components/User/SuggestedUser";

interface Props {
  users: BaseUser[];
}

export default function UserList({ users }: Props) {
  return (
    <Wrapper>
      {users.map((user) => {
        return <SuggestedUserSmall user={user} key={user.snapshot.id} />;
      })}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  align-content: flex-start;
  width: 100%;
`;
